module.exports = __webpack_public_path__ + "static/media/posters-banner-IADR.33734324.png";